import React, {
    useState,
    useImperativeHandle,
    forwardRef,
    useEffect,
    useRef,
} from 'react';
import { Input, Icon } from 'semantic-ui-react';

interface TextFieldFilterProps {
    field?: string;
    onNewFilterChange?: (field: string, value: string) => void;
    parentFilterInstance?: any;
    column: any;
    t: any;
}

const TextFieldFilter = forwardRef((props: TextFieldFilterProps, ref) => {
    const { field, onNewFilterChange, parentFilterInstance, column, t } = props;
    const [filterText, setFilterText] = useState('');

    const onFilterChange = (value: string) => {
        setFilterText(value);
        if (value === '' && onNewFilterChange && field) {
            onNewFilterChange(field, '');
        }
    };

    const triggerFilter = () => {
        if (onNewFilterChange && field && filterText.length > 0) {
            onNewFilterChange(field, filterText);
        }
    };

    const onInputKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.key === 'Enter') {
            triggerFilter();
        }
    };

    return (
        <div
            className="text-filter-container"
            style={{
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                padding: '4px',
                width: '100%',
            }}
        >
            <Input
                fluid={true}
                style={{ width: '100%' }}
                placeholder={t('GLOBAL:ENTER_TEXT')}
                value={filterText}
                onChange={(e) => onFilterChange(e.target.value)}
                onKeyDown={onInputKeyDown}
                onBlur={triggerFilter}
                icon={
                    <Icon
                        name="search"
                        link={true}
                        onClick={triggerFilter}
                        style={{ cursor: 'pointer' }}
                        title={t('GLOBAL:SEARCH')}
                    />
                }
            />
        </div>
    );
});

export default TextFieldFilter;



// WEBPACK FOOTER //
// ./src/components/AgGridFilter/TextFieldFilter.tsx